/**
 * Shared mobile rules for the operator console.
 *
 * The console was built for a desk. Rishi asked for it on a phone, so the whole
 * thing now has a single breakpoint at 768px rather than a scatter of ad-hoc
 * numbers. Keep new rules on this constant so there is one place to move it.
 */

export const MOBILE = '@media (max-width: 768px)';

/**
 * Near-fullscreen dialogs on a phone.
 *
 * MUI centres a dialog and caps it at `sm`, which on a 375px screen leaves a
 * cramped box with the confirm buttons close to the edge. This gives it the
 * screen back without switching to `fullScreen`, which loses the rounded card
 * the rest of the console is drawn in. Spread onto a Dialog's `sx`.
 */
export const MOBILE_DIALOG = {
    [MOBILE]: {
        '& .MuiDialog-paper': {
            margin: '12px',
            width: 'calc(100% - 24px)',
            maxWidth: 'none',
        },
    },
};
